import { ShopifyPageType } from "@redotech/redo-model/shopify/page-types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const SelectorCheckResultSchema = z.object({
  foundSelectorCount: z.number(),
  url: z.string(),
  error: z.boolean(),
});

export type SelectorCheckResult = z.infer<typeof SelectorCheckResultSchema>;

export const checkShopifySelector = {
  name: "checkShopifySelector" as const,
  input: z.object({
    selector: z.string(),
    pageType: createEnum(ShopifyPageType),
  }),
  output: SelectorCheckResultSchema,
};
